//#region Icons
import TimerIcon from "icons/TimerIcon";
//#endregion
//#region Styles
import { 
    Container } from "./styles";
//#endregion

const placeholder = "Elige una hora";
const InputTime = ({
    text, 
    error,
    disabled,
    onClick 
}) => {
    const getClassName = () => {
        const classList = [];
        !text && classList.push("no-content");
        error && classList.push("error");
        disabled && classList.push("disabled");
        return classList.join(" ");
    }
    return (
        <Container 
            className={getClassName()} 
            onClick={onClick}>
            <span>{text || placeholder}</span>
            <TimerIcon/>
        </Container>
    );
}

export default InputTime;